import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-nav',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.nav/view.scss */
/* src/app/component.nav/view.scss: no such file or directory */`],
})
export class ComponentNavComponent implements OnInit {
    public mobileMenuOpen: boolean = false;
    public showLoginModal: boolean = false;
    public loginId: string = '';
    public loginPw: string = '';
    public loginError: string = '';
    public isLoggedIn: boolean = false;
    public userName: string = '';
    public userRole: string = '';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.checkSession();
        await this.service.render();
    }

    public async checkSession() {
        try {
            const { code, data } = await wiz.call("session");
            if (code === 200 && data.loggedIn) {
                this.isLoggedIn = true;
                this.userName = data.name || data.id;
                this.userRole = data.role || 'user';
            }
        } catch (e) { }
    }

    public openLogin() {
        this.loginId = '';
        this.loginPw = '';
        this.loginError = '';
        this.showLoginModal = true;
        this.service.render();
    }

    public async login() {
        if (!this.loginId || !this.loginPw) {
            this.loginError = '아이디와 비밀번호를 입력하세요.';
            await this.service.render();
            return;
        }
        const { code, data } = await wiz.call("login", { id: this.loginId, password: this.loginPw });
        if (code === 200) {
            this.showLoginModal = false;
            this.isLoggedIn = true;
            this.userName = data.name || this.loginId;
            this.userRole = data.role || 'user';
            this.loginError = '';
        } else {
            this.loginError = data?.message || '로그인에 실패했습니다.';
        }
        await this.service.render();
    }

    public async logout() {
        await wiz.call("logout");
        this.isLoggedIn = false;
        this.userName = '';
        this.userRole = '';
        this.service.href('/');
    }

    public toggleMobileMenu() {
        this.mobileMenuOpen = !this.mobileMenuOpen;
    }

    public isActive(link: string) {
        if (link === '/') return location.pathname === '/';
        return location.pathname === link || location.pathname.startsWith(link + '/');
    }

    public activeClass(link: string) {
        if (this.isActive(link)) {
            return 'text-[#4A6FD8] bg-[#EEF2FF] font-semibold';
        }
        return 'text-gray-600 hover:bg-gray-100 hover:text-gray-900';
    }
}

export default ComponentNavComponent;